import api from '@motionelements/core/src/api/base-api-v2';
import { snakeCaseKeys } from '@motionelements/core/src/helpers/string.js';

const baseUrl = '/v2/artist/elements';

// eslint-disable-next-line
export const uploadS3Url = () => {
  return api.request('post', `${baseUrl}/upload-url`);
};

// eslint-disable-next-line
export const createElement = (data) => {
  return api.request('post', baseUrl, {
    data, // { url, mediaType, originalPath, assetUrl, assetText }
  });
};

// eslint-disable-next-line
export const addElementVariant = (elementId, { url, originalPath }) => {
  return api.request('post', `${baseUrl}/${elementId}/variants`, {
    data: {
      url,
      originalPath,
    },
  });
};

// eslint-disable-next-line
export const deleteElementVariant = (elementId, variantId) => {
  return api.request('delete', `/v2/artist/variants/${variantId}`);
};

// eslint-disable-next-line
export const setDefaultElementVariant = (variantId) => {
  return api.request('patch', `/v2/artist/variants/${variantId}`, {
    data: {
      master: true,
    },
  });
};

export const listElements = async (params, axiosConfig) => {
  params = params || {};
  const config = {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
    ...(axiosConfig || {}),
  };

  return api.request('get', baseUrl, config);
};

export const getElementsListCount = async (params, axiosConfig) => {
  const url = '/v2/artist/elements/stats';
  return api.request('get', url, {
    params: {
      ...api.getLocaleParams(),
      ...(params || {}),
    },
    ...(axiosConfig || {}),
  });
};

export const getElementsStats = async (params, axiosConfig) => {
  const url = '/v2/artist/elements/stats';
  return api.request('get', url, {
    params: {
      ...api.getLocaleParams(),
      ...(params || {}),
    },
    ...(axiosConfig || {}),
  });
};

export const getElementsList = async (params, axiosConfig) => listElements(params, axiosConfig);
// const url = '/v2/artist/elements';
//
// params = params || {};
//
// if (!params.sort) {
//   params.sort = '-created_at';
// }
//
// return api.request('get', url, {
//   params: {
//     ...api.getLocaleParams(),
//     ...params,
//   },
//   ...(axiosConfig || {}),
// });

// eslint-disable-next-line
export const listElementStems = (id, params, axiosConfig) => {
  return api.get(`${baseUrl}/${id}/stems`, {
    params,
    ...(axiosConfig || {}),
  });
};

export const exportElements = async (params) => {
  const url = '/v2/artist/elements/export';
  const request = api.request('post', url, {
    data: params,
  });
  return request;
};

export const regenerateElementsPreviews = async (skus) => {
  const url = '/v2/artist/elements/previews';
  const request = api.request('post', url, {
    data: { skus: skus },
  }); // toDo POST /v2/artist/elements/previews - Error 405
  return request;
};

export const publishElement = async (sku) => {
  const url = `/v2/artist/elements/${sku}/publish`;
  const request = api.request('post', url, {
    // data: { skus: skus },
  });
  return request;
};

export const publishElements = async (skus) => {
  const url = '/v2/artist/elements/publish';
  const request = api.request('post', url, {
    data: { skus: skus },
  });
  return request;
};

export const unpublishElement = async (sku) => {
  const url = `/v2/artist/elements/${sku}/unpublish`;
  const request = api.request('post', url, {
    // data: { skus: skus },
  });
  return request;
};

export const unpublishElements = async (skus) => {
  const url = '/v2/artist/elements/unpublish';
  const request = api.request('post', url, {
    data: { skus: skus },
  });
  return request;
};

export const deleteElement = async (sku) => {
  const url = `/v2/artist/elements/${sku}`;
  const request = api.request('delete', url, {
    // data: { skus: skus },
  });
  return request;
};

export const deleteElements = async (skus) => {
  const url = '/v2/artist/elements';
  const request = api.request('delete', url, {
    data: { skus: skus },
  });
  return request;
};

export const getPriceTemplates = async () => {
  const url = '/v2/artist/templates?sort=-id&type=price';
  const request = api.request('get', url);
  return request;
};

export const getMetadataTemplates = async (params) => {
  const url = '/v2/artist/templates?sort=-id&type=metadata';
  const request = api.request('get', url, { params });
  return request;
};

export const applyTemplate = async (templateId, skus) => {
  console.log('applyTemplate', templateId, skus);
  if (!templateId || !skus.length) return false;

  const url = `/v2/artist/templates/${templateId}/apply`;
  const request = api.request('post', url, {
    data: { skus: skus },
  });
  return request;
};

export const applyPriceTemplate = async (templateId, skus) => {
  console.log('applyPriceTemplate', templateId, skus);
  if (!templateId || !skus.length) return false;

  const url = `/v2/artist/templates/${templateId}/apply`;
  const request = api.request('post', url, {
    data: { skus: skus },
  });
  return request;
};

// use for element-edit
export const getElementsDetail = async ({ sku, payload }) => {
  const url = `/artist/elements/${sku}?fields[element]=edit`;
  const config = {
    data: payload,
  };
  return api.request('get', url, config);
};

/// added


export const getArtistElementsList = async ({ payload }) => {
  const url = '/artist/elements';
  const config = {
    data: payload,
  };
  return api.get(url, config);
};

export const getArtistElement = async (elementId, params, axiosConfig) => {
  params = params || {};
  // const url = `/v2/artist/elements/${elementId}?fields[element]=edit`;
  const url = `/v2/artist/elements/${elementId}`;
  return api.get(url, {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
    ...(axiosConfig || {}),
  });
};

export const listElementsCategories = async (params, axiosConfig) => {
  const url = '/v2/artist/elements/categories';

  params = snakeCaseKeys(params) || {};
  axiosConfig = axiosConfig || {};

  const config = {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
    ...axiosConfig,
  };

  return api
    .request('get', url, config)
    .then(({ data: { data } }) => data);
};

export const updateArtistElement = async (elementId, data) => {
  const url = `/v2/artist/elements/${elementId}`;
  return api.request('patch', url, {
    data: data,
    params: api.getLocaleParams(),
    storeValidationErrors: true,
  });
};

// export const deleteArtistElement = async () => {
// };

export const addElementPreview = async (elementId, data) => {
  const url = `/v2/artist/elements/${elementId}/previews`;
  return api.request('post', url, {
    data,
  });
};

// MUSIC ARTWORK
// export const addElementPreviewMusic = async (elementId, params) => {
//   const url = `/v2/artist/elements/${elementId}/preview-music`;
//   return api.request('post', url, {
//     data: {
//       url: params.url,
//     },
//   });
// };

export const replaceElementPreview = async (elementId, { type, urls }) => {
  const url = `/v2/artist/elements/${elementId}/previews`;
  const data = Array.isArray(urls) ? { urls, type } : { url: urls, type };
  return api.request('post', url, { data });
};

export const deleteElementPreview = async (elementId, previewId, data) => {
  const url = `/v2/artist/elements/${elementId}/previews/${previewId}`;
  return api.request('delete', url, {
    data,
  });
};

export const regenerateElementPreviews = async (elementId) => {
  const url = `/v2/artist/elements/${elementId}/previews`;
  return api.request('post', url);
};

// eslint-disable-next-line
export const updateAlbumArt = (elementId, data) => {
  return api.request('put', `/v2/artist/elements/${elementId}/album-art`, { data });
};

// TUTORIALS
export const addElementTutorial = async (elementId, params) => {
  const url = `/v2/artist/elements/${elementId}/tutorials`;
  return api.request('post', url, {
    data: {
      // format: params.format,
      url: params.url,
    },
  });
};

// P.R.O. INFORMATION
const creatorsUrl = '/v2/artist/creators';
export const getListCreators = params => api.get(creatorsUrl, { params: { ...params } })
  .then(({ data }) => data);

export const createCreator = data => api.request('post', creatorsUrl, { data });

export const updateCreator = (data, id) => api.request('patch', `${creatorsUrl}/${id}`, { data });

export const deleteCreator = id => api.request('delete', `${creatorsUrl}/${id}`);
